import { Helmet } from "react-helmet-async";
import seoPages from "../../utils/seoPages.json";

const SITE_URL = "https://commenter.ai";

// Public pages take their title and description from seoPages.json, the same
// list src/prerenderMeta.js writes into each page's raw HTML at build time, so
// crawlers that don't run JavaScript see the same tags. Other pages pass a title.
const Seo = ({ path, title, description, noindex = false }) => {
  const page = seoPages[path];
  const pageTitle = page ? page.title : title;
  const pageDescription = page ? page.description : description;
  const url = path ? SITE_URL + path : null;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      {pageDescription && <meta name="description" content={pageDescription} />}
      {url && <link rel="canonical" href={url} />}
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:title" content={pageTitle} />
      {pageDescription && <meta property="og:description" content={pageDescription} />}
      {url && <meta property="og:url" content={url} />}
    </Helmet>
  );
};

export default Seo;
